import { render } from "./VideoBanner.vue?vue&type=template&id=4019c9ca"
import script from "./VideoBanner.vue?vue&type=script&lang=js"
export * from "./VideoBanner.vue?vue&type=script&lang=js"

import "./VideoBanner.vue?vue&type=style&index=0&id=4019c9ca&lang=css"

import exportComponent from "/Users/larijuva/suha-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__